import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChangePwdPageRoutingModule } from './change-pwd-routing.module';

import { ChangePwdPage } from './change-pwd.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ChangePwdPageRoutingModule
  ],
  declarations: [ChangePwdPage]
})
export class ChangePwdPageModule {}
